<template>
  <div class="echart echart-line" :id="echartId" :style="{width: width,height:height}"></div>
</template>

<script>
import echarts from "echarts";

export default {
  name: "EchartsVue",
  data() {
    return {
      chart: null
    };
  },
  props: {
    id: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    },
    option: {
      type: Object,
      required: true
    }
  },
  watch: {
    option: {
      deep: true,
      handler: function() {
        this.setOption();
      }
    }
  },
  computed: {
    echartId: function() {
      return `echart-vue-${this.id}`;
    }
  },
  methods: {
    resizeChart: function() {
      if (this.chart) this.chart.resize();
    },
    init() {
      this.chart = echarts.init(document.getElementById(this.echartId));
      this.setOption();

      window.addEventListener("resize", this.resizeChart);
    },
    setOption() {
      if (this.chart) this.chart.setOption(this.option);
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.chart = null;
    window.removeEventListener("resize", this.resizeChart);
  }
};
</script>

<style lang="less" scoped>
</style>

